module.exports = __webpack_public_path__ + "img/whitted.d0b2288f.png";